import { render, staticRenderFns } from "./sizeChange.vue?vue&type=template&id=60185ac4&scoped=true"
import script from "./sizeChange.vue?vue&type=script&lang=js"
export * from "./sizeChange.vue?vue&type=script&lang=js"
import style0 from "./sizeChange.vue?vue&type=style&index=0&id=60185ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60185ac4",
  null
  
)

export default component.exports